import React, { useState } from "react";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // There's no /api/contact endpoint yet
    // backend spec), so this is a front-end-only confirmation for now.
    // Wiring this up to a real backend route is a natural follow-up task.
    setSubmitted(true);
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <section className="section">
      <div className="container">
        <h1 className="section-title">Get In Touch</h1>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "3rem",
          }}
        >
          {/* Contact info */}
          <div>
            <h2 style={{ color: "var(--text-primary)", fontSize: "1.5rem", marginBottom: "1.5rem" }}>
              Let's Build Something Great Together
            </h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                <svg style={{ width: 20, height: 20, color: "var(--accent)", flexShrink: 0 }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:srihari95027@gmail.com" style={{ color: "var(--text-muted)" }}>
                  srihari95027@gmail.com
                </a>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                <svg style={{ width: 20, height: 20, color: "var(--accent)", flexShrink: 0 }} fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
                </svg>
                <a href="https://github.com/ksr2005" target="_blank" rel="noopener noreferrer" style={{ color: "var(--text-muted)" }}>
                  github.com/ksr2005
                </a>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                <svg style={{ width: 20, height: 20, color: "var(--accent)", flexShrink: 0 }} fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2zm2-3a2 2 0 100-4 2 2 0 000 4z" />
                </svg>
                <a
                  href="https://www.linkedin.com/in/srihari-k-755559251"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "var(--text-muted)" }}
                >
                  linkedin.com/in/srihari-k-755559251
                </a>
              </div>
            </div>
          </div>

          {/* Contact form */}
          <div>
            {submitted && (
              <div
                className="badge badge-emerald"
                style={{ marginBottom: "1rem", display: "inline-flex" }}
              >
                Thanks! Your message has been noted.
              </div>
            )}
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                className="form-input"
                value={form.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                className="form-input"
                value={form.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Message"
                rows={4}
                className="form-textarea"
                value={form.message}
                onChange={handleChange}
                required
              />
              <button type="submit" className="btn btn-primary" style={{ width: "100%" }}>
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
